import React, { FC } from 'react'
import LinearProgress from '@material-ui/core/LinearProgress'

// loading component for suspense fallback
const Loader: FC = () => (
    <div className="App">
        <LinearProgress />
    </div>
)

export default Loader
